/**
 * @fileoverview Entity Picker folder item presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.FolderItem');

export class FolderItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {collapsed: true};
    this.onExpandClick = this.onExpandClick.bind(this);
  }

  /** Expand or collapse folder tree */
  onExpandClick(e) {
    this.setState(state => ({collapsed: !state.collapsed}));
  }

  render() {
    const hasChildren = this.props.children && this.props.children.length > 0;
    let childFolders;
    let expandCssClass = 'uep-folder-expand-button';
    expandCssClass += this.state.collapsed ? ' uep-folder-collapsed' : '';
    const childrenId = `uep-folder-${this.props.folder.id}`;

    if (hasChildren) {
      childFolders = (
        <li id={childrenId} className={this.state.collapsed ? 'uep-list-hidden' : ''}>
          <ul className="uep-folder-children">
            {this.props.children}
          </ul>
        </li>
      );
    }

    return (
      <React.Fragment>
        <li className="uep-item uep-folder-item">
          {hasChildren
          && <button
            type="button"
            className={expandCssClass}
            onClick={this.onExpandClick}
            aria-controls={childrenId}
            aria-expanded={!this.state.collapsed} />
          }
          <button type="button" onClick={this.props.onClick} className="uep-folder-button">
            {this.props.folder.label}
          </button>
        </li>
        {childFolders}
      </React.Fragment>
    );
  }
}
